import * as React from 'react';
import styled from 'styled-components';
const overlay = (props) => {
    return (React.createElement(Overlay, { style: { display: props.show ? 'block' : 'none' }, onClick: props.clicked }));
};
export default overlay;
const Overlay = styled.div `
  background-color: rgba(55, 55, 55, 0.7);
  height: 100vh;
  left: 0;
  position: fixed;
  top: 0;
  width: 100vw;
  z-index: 100;
`;
//# sourceMappingURL=Overlay.js.map


// WEBPACK FOOTER //
// ./src/components/Overlay.js